import $ from 'jquery';
import { useState } from 'react';

export function initMenuItem() {
    $(".navigation-menu a").each(function () {
        if (this.href === window.location.href) {
            $(this).parent().addClass("active"); // add active to li of the current link
            $(this).parent().parent().parent().addClass("active"); // add active class to an anchor
            $(this).parent().parent().parent().parent().parent().addClass("active"); // add active class to an anchor
        }
    });
}

export function getLanguage() {
    return (navigator.language || navigator.browserLanguage).split(/[-_]/)[0]
}

export function serializeArrayToJson(element) {
    
    const jsonObj = {}
    const data = $(`.` + element).serializeArray()
    data.map( each => {
        let key = each.name.replace('N_', 'count')
        jsonObj[key] = each.value
    })
    return jsonObj
}

export async function isLocatedTW() {
    let isLocatedTW = localStorage.getItem('isLocatedTW') || undefined;

    try {
        if(isLocatedTW === undefined) {
            let url = 'https://subscrib.worldcardteam.com/PRS/country/';
            const location_call = await fetch(url)
                .then(res => {
                    if(res.ok) return res
                    else throw Error(`Request rejected with status ${res.status}`)
                })
                .catch(console.error)
            if(location_call !== undefined) {
                let result = await location_call.json();
                if(result.data === 'TW') isLocatedTW = true
                isLocatedTW = result.data === 'TW' ? true : false
                localStorage.setItem('isLocatedTW', isLocatedTW)
            }
        }
        return localStorage.getItem('isLocatedTW')
    } catch (e) {
        return false;
    }
}
export async function getCountries() {
    let countries = localStorage.getItem('countries') || undefined
    
    try {
        if(!countries) {
            let url = process.env.REACT_APP_BASE_URL + 'api/trialcountry'
            const country_call = await fetch(url, { headers : { 'locale': 'en' } } )
                .then(res => {
                    if(res.ok) return res
                    else throw Error(`Request rejected with status ${res.status}`)
                })
                .catch(console.error)
        
            if(country_call !== undefined) {
                countries = await country_call.json()
                localStorage.setItem('countries', JSON.stringify(countries))
            }
        }
        return JSON.parse(localStorage.getItem('countries'))
    } catch(e) {
        return ''
    }
}

export const useInput = (initial) => {
    const[ value, setValue ] = useState(initial)
    return { 
        value,
        setValue,
        bind: { value, onChange: event => setValue(event.target.value) }
    }
}

export const validate = () => {
    let result = true;
    let inputs = document.querySelectorAll('input, select, textarea')
    inputs.forEach(input => {
        input.addEventListener('focus', function() {
            document.querySelectorAll('.form-group').forEach(item => item.removeAttribute('data-tip'))
        }, false)
    })
    const validateInputs = Array().filter.call(inputs, input => { return input.hasAttribute('required')})
    Array().some.call(validateInputs, input => { 
        if(!input.value) {
            input.parentNode.setAttribute('data-tip', '* This field is required')
            result = false
        }
    })
    return result
}